/**
 * Deep-merge a brand's translation overrides into an i18next instance.
 * Keys present in the override win; everything else falls back to the
 * base language bundles already registered on the instance.
 *
 * @param {import('i18next').i18n} i18nInstance - Initialized i18next instance
 * @param {Object|undefined} stringsOverride - Brand override bundle shaped
 *   `{ [lang]: { translation: {...} } }` (see src/langs/overrides/).
 */
const applyBrandOverrides = (i18nInstance, stringsOverride) => {
  if (!stringsOverride) return;

  Object.entries(stringsOverride).forEach(([lang, bundle]) => {
    if (bundle && bundle.translation) {
      i18nInstance.addResourceBundle(lang, 'translation', bundle.translation, true, true);
    }
  });
};

export default applyBrandOverrides;
